export default {
    name: 'header',
    component() {
        return {
            open: false,
            scrollTop: 0,
            visible: false,
            sticky: false,
            offset: 90,
            lastScrollTop: 0,

            init() {
                if(document.querySelector("[data-background-color]") != null) {
                    let pageBackground = document.querySelector("[data-background-color]").dataset.backgroundColor;
                    if(pageBackground == "beige") {
                        document.querySelector("body").classList.add("bg-gray-300");
                    } else {
                        document.querySelector("body").classList.remove("bg-white");
                    }
                }

                setTimeout(() => {
                    let headerHeight = document.querySelector(".header").getBoundingClientRect().height;
                    let footerHeight = document.querySelector("footer").getBoundingClientRect().height;

                    // let announcementBarHeight = 0;
                    // if(document.querySelector(".announcement-bar") != null) {
                    //   announcementBarHeight = document.querySelector(".announcement-bar").getBoundingClientRect().height;
                    // }
                  
                    document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
                    document.documentElement.style.setProperty("--footer-height", `${footerHeight}px`);
                  }, 10);

                  this.stickyNav();
                  window.addEventListener("scroll", () => {
                      this.stickyNav();
                  });

                // Initialize parallax effects after a short delay to ensure DOM is ready
                setTimeout(() => {
                    this.initParallaxEffects();
                }, 100);
            },

            initParallaxEffects() {
                const imgLeft = document.querySelector('[data-img-left]');
                const imgRight = document.querySelector('[data-img-right]');

                if(imgLeft != null) {
                    this.createParallax(imgLeft, -0.3); // Move left image slower (negative value for opposite direction)
                }

                if(imgRight != null) {
                    this.createParallax(imgRight, -0.2); // Move right image slower
                }
            },

            createParallax(element, speed = 0.2) {
                    // Check if element is still in DOM
                    if (!document.contains(element)) {
                        return;
                    }

                    // Set initial styles for better performance
                    gsap.set(element, {
                        force3D: true,
                        willChange: 'transform'
                    });

                    // Create parallax animation using ScrollTrigger
                    const tl = gsap.to(element, {
                        y: `${speed * 100}vh`,
                        ease: 'none',
                        scrollTrigger: {
                            trigger: element.closest('.block') || element.parentElement,
                            start: 'top bottom',
                            end: 'bottom top',
                            scrub: 1, // Smooth scrubbing
                            invalidateOnRefresh: true,
                            // onUpdate: (self) => {
                            //     // Optional: Add some easing for smoother movement
                            //     const progress = self.progress;
                            //     const easedProgress = this.easeInOutCubic(progress);
                            //     if (document.contains(element)) {
                            //         element.style.transform = `translateY(${speed * 100 * easedProgress}vh)`;
                            //     }
                            // },
                            onRefresh: () => {
                                // Recalculate on refresh for better performance
                                if (document.contains(element)) {
                                    gsap.set(element, { clearProps: 'transform' });
                                }
                            }
                        }
                    });

                    // Store reference for cleanup if needed
                    element._parallaxTl = tl;
            },

            easeInOutCubic(t) {
                return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
            },

            // animateProdItemText(item, incoming) {
            //     if(window.innerWidth > 999) {  
            //         let textTranslateFirst = item.querySelector('[data-text-translate-first]');
            //         let textTranslateSecond = item.querySelector('[data-text-translate-second]');
            //         let hoverVisible = textTranslateSecond.getBoundingClientRect().height;
            //         if(incoming) {
            //             textTranslateFirst.style.transform = `translateY(-${hoverVisible+20}px)`;
            //             textTranslateSecond.style.transform = `translateY(-${hoverVisible+50}px)`;
            //         } else {
            //             textTranslateFirst.style.transform = 'translateY(0)';
            //             textTranslateSecond.style.transform = 'translateY(0)';
            //         }
            //     }
            // },

            stickyNav() {
                const top =
                    window.scrollY ||
                    window.scrollTop ||
                    document.getElementsByTagName("html")[0].scrollTop;
                let st = window.pageYOffset || document.documentElement.scrollTop;
        
                if (top > this.offset) {
                    this.sticky = true;
                    if (st > this.lastScrollTop) {
                        this.visible = false;
                        this.lastScrollTop = st <= 0 ? 0 : st;
                    } else {
                        if (st + 100 < this.lastScrollTop) {
                            this.visible = true;
                            this.lastScrollTop = st <= 0 ? 0 : st;
                        }
                    }
                } else {
                    this.sticky = false;
                    this.visible = false;
                    this.lastScrollTop = st <= 0 ? 0 : st;
                }
            },
        }
    }
}